module.exports = __webpack_public_path__ + "img/di_status.922d01c8.svg";